import { ApiError } from "./ApiError";

export default class BadRequest extends ApiError {
  code = 400;
}
